export default {
  properties: {
    default: { type: 'string' },
  },
};
